module.exports = __webpack_public_path__ + "img/Logo.75e84f4b.png";